import { render, staticRenderFns } from "./IbCard.vue?vue&type=template&id=a0161026&scoped=true"
import script from "./IbCard.vue?vue&type=script&lang=js"
export * from "./IbCard.vue?vue&type=script&lang=js"
import style0 from "./IbCard.vue?vue&type=style&index=0&id=a0161026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0161026",
  null
  
)

export default component.exports